<template>
	<div class="centerWidth">
		<div class="gaokao">
			<!-- <div class="gaokao-nav">
				<span>个人中心 ></span>
				<span>学生学情档案</span>
			</div> -->
			<section class="gaokao-content">
				<div class="my-title">学生学情档案</div>
				<article class="fenNum_head flex zhong center xieqDiv">
					<p class="on">
						<i></i>
						<span>基本信息</span>
					</p>
					<p class="on">
						<i></i>
						<span>成绩信息</span>
					</p>
					<p class="on">
						<i></i>
						<span>综合信息</span>
					</p>
					<p>
						<i></i>
						<span>偏爱方向</span>
					</p>
				</article>
				<article class="general-content">
					<div class="general-remark">
						<p>1、请如实填写在高中期间参与过的社会活动或获奖记录，如果无任何社会活动或获奖记录请跳过此步。</p>
						<p>2、“ 高中期间参与过的社会活动”可填写高中阶段参与的科学研究、创新实践、文学创作、志愿服务、社团活动、学校或班团学生工作等。</p>
						<p>3、“ 高中期间的获奖记录”可填写高中阶段获得的省级(含)以上学科竞赛奖励、校级(含)以上个人荣誉、本人所具备的文艺或体育特长等。</p>
					</div>
					<div class="general-add">
						<div class="add-c01" @click="AddDiv(1)">
							<img src="../../../image/add.png" />
							<span>增加高中期间参与过的社会活动</span>
						</div>
						<div class="add-ctxt">或者</div>
						<div class="add-c01" @click="AddDiv(2)">
							<img src="../../../image/add.png" />
							<span>增加高中期间参与过的获奖记录</span>
						</div>
					</div>
					<div class="general-from" v-for="(item, index) in list" :key="index">
						<p class="general-from-tit">{{ item.TypeId == 1 ? '社会活动' : '获奖记录' }}</p>
						<div class="general-from-con">
							<div class="from-c01">
								<p>{{ item.TypeId == 1 ? '活动名称' : '获奖名称' }}：</p>
								<input placeholder="请输入" v-model="item.Name" />
							</div>
							<div class="from-c01" v-show="item.TypeId == 1">
								<p>担任角色：</p>
								<input placeholder="请输入" v-model="item.PlayRole" />
							</div>
							<div class="from-c01">
								<p>{{ item.TypeId == 1 ? '活动时间' : '获奖时间' }}：</p>
								<div class="flex zhong">
									<el-date-picker class="from-ipt" v-model="item.StartTime" type="date" placeholder="选择日期"></el-date-picker>
									<span class="from-ctxt">至</span>
									<el-date-picker class="from-ipt" v-model="item.EndTime" type="date" placeholder="选择日期"></el-date-picker>
								</div>
							</div>
							<div class="from-c01">
								<p>组织单位：</p>
								<input placeholder="请输入" v-model="item.Organizational" />
							</div>
						</div>
					</div>
				</article>
				<div class="test-btn">
					<button class="gaokao-btn" @click="goTestb()">上一步</button>
					<button class="gaokao-btn" @click="goTestd()">下一步</button>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			list: [],
			sid: 0,
			IsCke: true
		};
	},
	// 加载
	created() {
		var that = this;

		var sid = that.$route.query.sid;
		if (sid > 0) {
			console.log('有ID', sid);
			that.sid = sid;
			that.GetParticipationActivitiesBySid();
		}
	},
	methods: {
		// 获取列表
		GetParticipationActivitiesBySid: function() {
			var that = this;

			that.$api.HtppRequest(
				'SystemData/GetParticipationActivitiesBySid?sid=' + that.sid,
				'GET',
				{},
				function(res) {
					console.log('获取', res);

					if (res.flag) {
						var list = res.list;
						if (list.length > 0) {
							list.map(itme => {
								that.list.push({
									TypeId: itme.TypeId,
									Name: itme.Name,
									StartTime: itme.StartTime,
									EndTime: itme.EndTime,
									PlayRole: itme.PlayRole,
									Organizational: itme.Organizational
								});
							});
						}
					}
				},
				function(err) {
					console.log(err);
				}
			);
		},
		AddDiv(typeid) {
			var that = this;

			if (typeid === 1) {
				var obj = {
					TypeId: 1,
					Name: '',
					StartTime: '',
					EndTime: '',
					PlayRole: '',
					Organizational: ''
				};
				that.list.push(obj);
			} else {
				var obj2 = {
					TypeId: 2,
					Name: '',
					StartTime: '',
					EndTime: '',
					PlayRole: '',
					Organizational: ''
				};
				that.list.push(obj2);
			}
		},
		// 上一步
		goTestb() {
			this.$router.push({ path: '/grade', query: { sid: this.sid } });
		},
		// 下一步
		goTestd() {
			var that = this;
			if (!that.IsCke) {
				return;
			}

			var listJson = '';
			var islist = true;
			// that.list.map(itme => {
			// 	if (itme.TypeId === 1) {
			// 		if (itme.Name === '' || itme.StartTime === '' || itme.EndTime === '' || itme.PlayRole === '' || itme.Organizational === '') {
			// 			islist = false;
			// 		}
			// 	} else {
			// 		if (itme.Name === '' || itme.StartTime === '' || itme.EndTime === '' || itme.Organizational === '') {
			// 			islist = false;
			// 		}
			// 	}
			// });
			if (islist) {
				if (that.list.length > 0) {
					listJson = JSON.stringify(that.list);
				}

				that.IsCke = false;
				that.$api.HtppRequest(
					'SystemData/AddParticipationActivities',
					'POST',
					{
						SAR_Id: that.sid,
						ListStr: listJson
					},
					function(res) {
						console.log('添加', res);

						if (res.flag) {
							that.$router.push({ path: '/direction', query: { sid: that.sid } });
						}
						that.IsCke = true;
					},
					function(err) {
						console.log(err);
						that.IsCke = true;
					}
				);
			} else {
				that.$util.showError('请完善社会活动或获奖记录');
				return false;
			}
		}
	}
};
</script>

<style scoped>
.gaokao {
	width: 100%;
	height: auto;
	overflow: hidden;
}
.gaokao-nav {
	width: 100%;
	display: flex;
	align-items: center;
	padding: 20px 0;
}
.gaokao-nav span {
	font-size: 15px;
	color: #333;
}
.gaokao-nav span:last-child {
	color: #333;
}
.fenNum_head {
	margin-top: 20px;
}
/* gaokao-content */
.gaokao-content {
	padding: 0 20px;
	width: 100%;
	height: auto;
	overflow: hidden;
	background-color: #fff;
	margin-bottom: 25px;
}
/* general-content */
.general-content {
	width: 100%;
	height: auto;
	overflow: hidden;
}
.general-remark {
	margin: 30px 0;
	width: 100%;
	height: auto;
	background-color: #f7f7f7;
	padding: 20px 30px;
}
.general-remark p {
	font-size: 15px;
	color: #333;
	padding-bottom: 10px;
}
/* general-add */
.general-add {
	width: 100%;
	height: auto;
	display: flex;
	align-items: center;
}
.add-c01 {
	width: calc((100% - 80px) / 2);
	height: auto;
	background-color: #f7f7f7;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 20px 0;
}
.add-c01 img {
	width: 20px;
	height: 20px;
	display: block;
	margin-right: 10px;
}
.add-c01 span {
	font-size: 16px;
	color: #333;
}
.add-ctxt {
	width: 80px;
	text-align: center;
	font-size: 16px;
	color: #999;
}
/* general-from */
.general-from {
	width: 100%;
	height: auto;
	overflow: hidden;
	border: 1px solid #333;
	padding-bottom: 20px;
	margin: 20px 0;
}
.general-from-tit {
	padding: 20px 0;
	text-align: center;
	font-size: 16px;
	color: #333;
}
.general-from-con {
	width: 100%;
	height: auto;
}
.from-c01 {
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 10px;
}
.from-c01:last-child {
	margin-bottom: 0px;
}
.from-c01 p {
	width: 80px;
	font-size: 15px;
	color: #333;
	text-align: right;
}
.from-c01 input {
	width: 300px;
	height: 40px;
	line-height: 38px;
	padding: 0 10px;
	border: 1px solid #eee;
	border-radius: 4px;
	font-size: 15px;
	color: #333;
}
.from-c01 input::-webkit-input-placeholder {
	color: #999;
}
.from-c01 input:-moz-placeholder {
	color: #999;
}
.from-c01 input:-ms-input-placeholder {
	color: #999;
}
.from-ipt {
	width: 130px;
}
.from-ctxt {
	font-size: 15px;
	color: #333;
	padding: 0 10px;
}

.test-btn {
	display: flex;
	align-items: center;
	justify-content: center;
}
.test-btn button {
	margin-left: 20px;
	margin-right: 20px;
}
.gaokao-btn {
	width: 200px;
	height: 40px;
	background-color: #333;
	border-radius: 6px;
	font-size: 16px;
	color: #fff;
	line-height: 40px;
	margin: 50px auto;
	display: block;
}
</style>
